import * as React from 'react';
//import "../index.scss";

export default class WaitLoading extends React.Component<{}, {}> {
    public render() {
        return (
            //<img className="loadingImg" src={require('../../core/ui/waiting.gif')} />
            <div className="k-loading-mask">
                <span className="k-loading-text">Loading</span>
                <div className="k-loading-image" />
                <div className="k-loading-color" />
            </div>
        );
    }

}